var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{class:{'is-active':_vm.isActive},on:{"click":_vm.toggleClick}},[_c('i',{class:'icon-'+ _vm.icon})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }